import clsx from "clsx";
import React from "react";

import { Label, Paragraph } from "@fronterahealth/frontera-ui-components";

import { EhrStoredFieldPartsFragment } from "@api/graphql/types-and-hooks";
import { StoredHtml } from "@pages/ClientEhrProgramming/StoredHtml";
import { looksLikeHtml } from "@pages/ClientEhrProgramming/looksLikeHtml";

interface EhrStoredFieldListProps {
  fields: EhrStoredFieldPartsFragment[];
}

// Every stored column is listed, including empty ones, so missing data is visible.
export const EhrStoredFieldList: React.FC<EhrStoredFieldListProps> = ({ fields }) => {
  return (
    <dl className="grid grid-cols-[minmax(10rem,16rem)_1fr] gap-x-6 gap-y-3">
      {fields.map((field) => {
        const isEmpty = field.value === null || field.value === undefined || field.value === "";
        return (
          <React.Fragment key={field.key}>
            <dt>
              <Label size="small">{field.key}</Label>
            </dt>
            <dd className="min-w-0">
              {field.value && looksLikeHtml(field.value) ? (
                <StoredHtml html={field.value} className="text-sm" />
              ) : (
                <Paragraph
                  size="small"
                  colorType={isEmpty ? "secondary" : "primary"}
                  className={clsx(
                    "whitespace-pre-wrap break-words",
                    !isEmpty && field.value?.includes("\n") && "font-mono",
                  )}
                >
                  {isEmpty ? "––" : field.value}
                </Paragraph>
              )}
            </dd>
          </React.Fragment>
        );
      })}
    </dl>
  );
};
